export const tr = {
    degree: '°C',
    from: 'min.\r',
    to: 'maks.\r',
    'warning-one-more-item': 'En az bir değer seçilmelidir'
};
